var _clipPath, _circle, _circle2, _circle3, _path, _use, _use2, _use3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 267 267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 267,
    height: 267
  }))), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m146.396 44.921-.624-.267.624.267zm17.833 176.42-2.407-1.425-7.133 1.782-6.242-3.92v1.514l-1.516-2.049 1.784-1.782-.268-5.346h2.05l1.25-3.564 1.426-.624-1.16-1.782 1.784-.624-.268-2.673-1.783-.89 2.318-.268-1.426-6.504-3.567-3.564-2.14.89.892 2.941h-7.4l-6.242-2.673-2.407-1.158-11.859-2.673-.892 1.425-4.19.357h-1.16l-1.783 2.94-5.082-3.564-2.675.89.357 2.407-6.598-3.564-.268 2.316-6.508-2.94-.357.267-3.21 1.248-.624-2.406-7.757-3.831-8.292-2.674-1.516-6.86v-1.515l-3.21-5.88 1.427-7.129-2.675-.89-.892-3.03 4.458-.535h-2.05l.267-4.455-6.509 2.05-.267-1.783-.892 3.297-3.567 1.426-2.407-2.317-.892-2.406-.891-4.722 2.05-1.515.892 1.159.624-1.426-1.515-10.692 2.407.534 1.159-11.226.357-.357 2.318-1.425-2.942.267-1.16-2.673 5.35-5.97-4.815-.891-3.566 3.564-1.427-4.099-2.14 2.94-.535-2.049-2.674.891-1.784.892 1.427-5.347-1.16-.623.625-1.515-1.516.356-.267-3.029h5.617l-.268-1.426h-1.783l-3.299-5.702-1.783.624-1.16-2.05-.623 1.782-1.784-1.247 1.784-1.158-2.675-.891.624-1.515-2.14-1.159-.535-4.722-2.14-.624 1.248-.89-2.407-6.238.267-2.049.892-6.237h1.783l-.535 3.831 4.458 6.237 3.21 4.188 6.598 1.782v.267l.892-1.514 3.567 4.187 1.783 2.05.891.89 10.076 4.812 1.783.891.624.535 4.726 5.702 2.675-1.247 19.615-4.455.625-3.564L97 94.55l-.267-1.159.891-.623 4.191-1.515v-4.099l1.427-1.515 1.783-6.86-.892-2.673 4.19-10.069v-6.237h2.052l2.407-3.564 2.942-.891.357-3.297 4.102-4.99 1.783.892 8.381-3.03.892-.89 1.783-1.783-.624-2.94h1.783l.892 4.722 9.183 2.139 1.516-1.515.624.267 8.025 1.782.267-.267 4.191-2.406.268 2.673 3.566.357 2.943 2.316.624.624 4.458 3.831 5.35.357 3.299.534 4.101-1.425.357 2.673 1.783 1.158 1.427-2.673h1.783l1.248 6.86 1.427.268-.268 2.406-.267.267h.535l3.566-1.782 3.3-1.158 9.183 3.207 1.783-.534.624 3.207 2.408.357-.624-1.515h2.05l.624 3.297 2.408-2.673 5.617 3.564 1.516 6.504-2.407.624.624 4.99.891 1.514 6.242 15.771-3.3 2.94-.267 3.565-2.675 3.296 2.943 2.05-1.16.89 2.675 2.674 4.102.624 1.248 1.782 1.16 2.316 2.942 1.248 3.566-2.406 2.408.267-2.943 4.188 2.943 7.752-3.567 2.94 1.516 4.722-.892 4.188 1.783 2.406 4.726.891-4.726 6.504.892 1.159 1.16 1.247-2.052 3.208 2.051 1.247-10.432 8.554 2.408 5.97-.625 3.564-3.566 1.158-.892 3.03-4.101 1.782-1.248 3.83-.892 2.05 4.19 2.139-6.24.534 1.515 3.297-3.032 2.94-4.725.891-1.516 2.673 3.566 1.782-6.776 6.238 2.05 3.296-5.349-1.158-5.974 3.564-8.024 3.831-1.784 2.673-1.159-.89 1.16-2.674-5.35 2.05-1.16-2.05-8.024 4.723-3.567-1.159-6.509 1.159-1.783-.891M166.28 50l-.625-.624h-.267v.357h.624l.268.267zm-2.051 171.342 1.783.89-1.783-.89zm0 0 1.783.89M39.044 98.74l.357-2.139-3.299-2.05 2.942 4.189zm-7.133-16.395h-1.783l.892 2.673.891-2.317v-.356zm-.891-2.673-.892.89 1.783 1.248-.891-2.138zm8.024 19.068.357-2.139-3.299-2.05 2.942 4.189zm-7.133-16.395h-1.783l.892 2.673.891-2.317v-.356zm-.891-2.673-.892.89 1.783 1.248-.891-2.138zm8.024 19.068.357-2.139-3.299-2.05 2.942 4.189zm-7.133-16.395h-1.783l.892 2.673.891-2.317v-.356zm-.891-2.673-.892.89 1.783 1.248-.891-2.138zm5.35-6.237v-2.317l-2.051.535.267 1.514 1.784.268zm-2.319-6.505.535 1.159 1.249-2.673-1.784 1.247v.267zm2.319 6.505v-2.317l-2.051.535.267 1.514 1.784.268zm-2.319-6.505.535 1.159 1.249-2.673-1.784 1.247v.267zm2.319 6.505v-2.317l-2.051.535.267 1.514 1.784.268zm-2.319-6.505.535 1.159 1.249-2.673-1.784 1.247v.267zm31.742 90.884-2.05.267-1.784 2.406 2.943-.624.891-2.05zm0 0-2.05.267-1.784 2.406 2.943-.624.891-2.05zm0 0-2.05.267-1.784 2.406 2.943-.624.891-2.05zm2.14-60.322-.624-.534-1.783-.891 1.783.89.624.535z",
    style: {
      fill: "#fff"
    },
    transform: "translate(0 -1.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c",
    style: {
      fill: "none"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 133.5,
    r: 49.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 133.5,
    r: 92.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 133.5,
    r: 133
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M-100 133.5h467M133.5-100v467"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 267,
    height: 267,
    transform: "rotate(30 133.5 133.5)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 267,
    height: 267,
    transform: "rotate(60 133.5 133.5)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h267v267H0z",
    style: {
      fill: "#072b5f",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 267,
    height: 267,
    style: {
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 267,
    height: 267
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 267,
    height: 267,
    clipPath: "url(#d)",
    style: {
      stroke: "#072b5f",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAq);
export default __webpack_public_path__ + "static/media/aq.3a1d1ffe340d14ae17ae9696581237b7.svg";
export { ForwardRef as ReactComponent };